import selectors from './active_editor.selectors';

const module = {
  selectors,
};

export default module;
